import UsersPage from '../containers/Users/Users'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Users = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>
                <Header /> 
                <main> 
                    <UsersPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Users
